import React from 'react'

import { useParams } from 'react-router-dom'

import { Filters } from 'components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'

const FilterCommitteeUser = ({ filter }) => {
  const params = useParams()

  const committeeUsers = useFetch(service.dponet.committeeUsers.get, {
    committeeId: params.committeeId,
  })

  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Nome" name="userName" />
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        <option value="0">Ativo</option>
        <option value="1">Inativo</option>
      </select>
      <select textfieldinput="true" label="Perfil" name="profileId">
        <option value=""></option>
        {committeeUsers?.response?.data?.committeeUsers?.map(
          (committeeUser) => (
            <option
              key={committeeUser?.userProfile?.id}
              value={committeeUser?.userProfile?.id}
            >
              {committeeUser?.userProfile?.name}
            </option>
          ),
        )}
      </select>
      <select
        textfieldinput="true"
        label="Cargo no comitê"
        name="committeeRoleId"
      >
        <option value=""></option>
        {committeeUsers?.response?.data?.committeeUsers?.map(
          (committeeUser) => (
            <option
              key={committeeUser?.committeeRole?.id}
              value={committeeUser?.committeeRole?.id}
            >
              {committeeUser?.committeeRole?.name}
            </option>
          ),
        )}
      </select>
    </Filters>
  )
}

export default FilterCommitteeUser
